import { z } from 'zod';

/**
 * Queue names are the contract between the API process (which enqueues) and the
 * worker process (which consumes), so they live in the shared domain package
 * rather than being spelled out at each call site.
 */
export const QUEUE_SYSTEM_PING = 'system.ping';

export const systemPingPayloadSchema = z.object({
  note: z.string().min(1).max(200),
});
export type SystemPingPayload = z.infer<typeof systemPingPayloadSchema>;

/**
 * One message in `mail_messages`, handed to the worker to deliver. The job carries the row's id and
 * nothing else: the row is what holds the message, and a job id equal to it is what makes a second
 * send for the same message create nothing.
 */
export const QUEUE_MAIL_DELIVER = 'mail.deliver';

export const mailDeliverPayloadSchema = z.object({
  messageId: z.uuid(),
});
export type MailDeliverPayload = z.infer<typeof mailDeliverPayloadSchema>;

/**
 * Where pg-boss moves a `mail.deliver` job that failed for good — including one that failed without
 * its handler finishing, by expiry or a lost worker. Its handler marks a still-`pending` message
 * `failed`. The payload is the delivery job's own.
 */
export const QUEUE_MAIL_DEAD_LETTER = 'mail.dead-letter';
